// in src/myMenu.js
import React from 'react';
import { MenuItemLink, WithPermissions } from 'react-admin';

import DashboardIcon from '@material-ui/icons/Dashboard';
import UserIcon from '@material-ui/icons/GroupAdd';
import ClientIcon from '@material-ui/icons/Work';
import FolderIcon from '@material-ui/icons/Folder';

import ClientTypeIcon from '@material-ui/icons/Group';

//import DocumentTypeIcon from '@material-ui/icons/ViewCarousel';

      
/*
        <WithPermissions
            render={({ permissions }) => (
                permissions === 'admin'
                    ? <MenuItemLink to="/document_types" primaryText="Document Types" onClick={onMenuClick} leftIcon={<DocumentTypeIcon />} />
                    : null
            )}
        />
*/

const MyMenu = ({ onMenuClick, logout  }) => (
    <div>
        

         <WithPermissions
            render={({ permissions }) => (
                permissions === 'admin'
                    ? <MenuItemLink to="/" primaryText="Dashboard" onClick={onMenuClick} leftIcon={<DashboardIcon />}/>
                    : null
            )}
        />

  
        <WithPermissions
            render={({ permissions }) => (
                permissions === 'admin'
                    ? <MenuItemLink to="/client_types" primaryText="Client Types" onClick={onMenuClick} leftIcon={<ClientTypeIcon />} />
                    : null
            )}
        />

        <WithPermissions
            render={({ permissions }) => (
                permissions === 'admin'
                    ? <MenuItemLink to="/users" primaryText="Users" onClick={onMenuClick} leftIcon={<UserIcon />} />
                    : null
            )}
        />
          
         <WithPermissions
            render={({ permissions }) => (
                permissions === 'admin'  
                    ? <MenuItemLink to="/clients" primaryText="Clients" onClick={onMenuClick} leftIcon={<ClientIcon />}/>
                    : null
            )}
        />

         <MenuItemLink to="/folders" primaryText="Folders" onClick={onMenuClick} leftIcon={<FolderIcon />}/>

    </div>
);

export default  (MyMenu) ;
///
/*
<WithPermissions
            render={({ permissions }) => (
                permissions === 'owner' || permissions === 'administrator'
                    ? <MenuItemLink to="/document_types" primaryText="Document Types" onClick={onMenuClick} leftIcon={<DocumentTypeIcon />}/>
                    : null
            )}
        />
*/
